module.exports = __webpack_public_path__ + "img/KSC07981.e60b4cb2.jpg";